/**
 * /tenants/$slug/access-requests — list route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AccessRequestsPage } from "@/features/access-requests/pages/access-requests-page";
import { accessRequestsQueryKey, fetchAccessRequests } from "@/features/access-requests/queries";

export const Route = createFileRoute("/_authed/tenants/$slug/access-requests")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: accessRequestsQueryKey(context.tenant.id),
      queryFn: () => fetchAccessRequests(context.tenant.id),
    }),
  component: AccessRequestsPage,
});
